import React from 'react';
import salientIso from '../../assets/images/logos/salient-isotipo-blanco.png';

// Hero reutilizable alineado al Manual de Identidad (fondo navy + subrayado verde).
// - Sin imagen: contenido centrado + marca de agua de la salamandra.
// - Con imagen: foto difuminada a la derecha (se funde con el navy) + contenido a la izquierda.
const SectionHero = ({ badge, title, children, pb = 'pb-24', image, imagePos = 'center', imageContain = false, mascot }) => {
    // Imagen transparente (objeto que "flota" sobre el navy): object-contain, sin máscara.
    if (image && imageContain) {
        return (
            <section className={`bg-navy-gradient relative overflow-hidden pt-32 ${pb} min-h-[34rem] flex items-center`}>
                <div className="absolute -bottom-40 -left-32 w-[28rem] h-[28rem] bg-salient-primary/15 rounded-full blur-3xl"></div>
                <div className="absolute top-1/3 right-24 w-[26rem] h-[26rem] bg-salient-green/10 rounded-full blur-3xl"></div>
                {/* Difuminado gris/slate del lado derecho (detrás de la imagen flotante) */}
                <div
                    className="pointer-events-none absolute inset-0"
                    style={{ background: 'radial-gradient(80% 110% at 100% 45%, rgba(100,116,139,0.40), rgba(100,116,139,0) 58%)' }}
                ></div>
                <div
                    className="dot-grid pointer-events-none absolute top-24 left-6 w-32 h-24 opacity-40"
                    style={{ maskImage: 'linear-gradient(135deg,#000,transparent 75%)', WebkitMaskImage: 'linear-gradient(135deg,#000,transparent 75%)' }}
                ></div>

                {/* Degradado (detrás de la imagen) solo para legibilidad del texto a la izquierda */}
                <div className="absolute inset-0 bg-gradient-to-r from-salient-navy via-salient-navy/70 to-transparent"></div>

                {/* Imagen transparente, bajada para no quedar tras el navbar y a la derecha para no chocar con el texto */}
                <img
                    src={image}
                    alt=""
                    aria-hidden="true"
                    className="pointer-events-none select-none absolute right-0 top-24 bottom-4 w-[90%] sm:w-[62%] lg:w-[52%] object-contain object-center"
                />

                {/* Mascota (salamandra) sobre la mesa, a la derecha de la computadora */}
                {mascot && (
                    <img
                        src={mascot}
                        alt="Salamandra Salient"
                        className="pointer-events-none select-none absolute bottom-[6%] right-[10%] sm:right-[11%] lg:right-[12%] h-32 sm:h-40 lg:h-44 w-auto object-contain z-10 drop-shadow-2xl"
                    />
                )}

                <div className="contain relative z-10">
                    <div className="max-w-lg" data-aos="fade-right">
                        {badge && (
                            <span className="inline-block px-4 py-1 rounded-full bg-salient-green/20 border border-salient-green/40 text-salient-green text-sm font-semibold mb-6">
                                {badge}
                            </span>
                        )}
                        <h1 className="text-white font-bold text-4xl md:text-6xl mb-5">{title}</h1>
                        <span className="title-underline mb-6"></span>
                        {children}
                    </div>
                </div>
            </section>
        );
    }

    if (image) {
        return (
            <section className={`bg-navy-gradient relative overflow-hidden pt-32 ${pb} min-h-[34rem] flex items-center`}>
                {/* Foto difuminada hacia el fondo (derecha), con su brillo original */}
                <img
                    src={image}
                    alt=""
                    aria-hidden="true"
                    className="pointer-events-none select-none absolute inset-y-0 right-0 h-full w-full lg:w-[60%] object-cover"
                    style={{
                        objectPosition: imagePos,
                        maskImage: 'linear-gradient(to right, transparent 0%, #000 42%)',
                        WebkitMaskImage: 'linear-gradient(to right, transparent 0%, #000 42%)',
                    }}
                />
                <div className="absolute inset-0 bg-gradient-to-r from-salient-navy via-salient-navy/85 to-transparent"></div>
                {/* Difuminado gris/slate del lado izquierdo (sobre el navy, sin tocar la imagen) */}
                <div
                    className="pointer-events-none absolute inset-0"
                    style={{ background: 'radial-gradient(95% 120% at 0% 45%, rgba(100,116,139,0.38), rgba(100,116,139,0) 55%)' }}
                ></div>
                <div className="absolute -bottom-40 -left-32 w-[28rem] h-[28rem] bg-salient-primary/15 rounded-full blur-3xl"></div>
                <div
                    className="dot-grid pointer-events-none absolute top-24 left-6 w-32 h-24 opacity-40"
                    style={{ maskImage: 'linear-gradient(135deg,#000,transparent 75%)', WebkitMaskImage: 'linear-gradient(135deg,#000,transparent 75%)' }}
                ></div>

                <div className="contain relative z-10">
                    <div className="max-w-xl" data-aos="fade-right">
                        {badge && (
                            <span className="inline-block px-4 py-1 rounded-full bg-salient-green/20 border border-salient-green/40 text-salient-green text-sm font-semibold mb-6">
                                {badge}
                            </span>
                        )}
                        <h1 className="text-white font-bold text-4xl md:text-6xl mb-5">{title}</h1>
                        <span className="title-underline mb-6"></span>
                        {children}
                    </div>
                </div>
            </section>
        );
    }

    return (
        <section className={`bg-navy-gradient relative overflow-hidden pt-32 ${pb}`}>
            <div className="absolute -top-32 -right-32 w-[28rem] h-[28rem] bg-salient-green/10 rounded-full blur-3xl"></div>
            <div className="absolute -bottom-40 -left-32 w-[28rem] h-[28rem] bg-salient-primary/15 rounded-full blur-3xl"></div>

            {/* Marca de agua: isotipo salamandra */}
            <img
                src={salientIso}
                alt=""
                aria-hidden="true"
                className="pointer-events-none select-none absolute right-0 top-1/2 -translate-y-1/2 h-[150%] w-auto opacity-[0.05] hidden md:block"
            />
            {/* Patrón de puntos */}
            <div
                className="dot-grid pointer-events-none absolute top-24 left-6 w-32 h-24 opacity-40"
                style={{ maskImage: 'linear-gradient(135deg,#000,transparent 75%)', WebkitMaskImage: 'linear-gradient(135deg,#000,transparent 75%)' }}
            ></div>

            <div className="contain relative z-10 text-center max-w-3xl mx-auto" data-aos="fade-up">
                {badge && (
                    <span className="inline-block px-4 py-1 rounded-full bg-salient-green/20 border border-salient-green/40 text-salient-green text-sm font-semibold mb-6">
                        {badge}
                    </span>
                )}
                <h1 className="text-white font-bold text-4xl md:text-6xl mb-5">{title}</h1>
                <span className="title-underline mx-auto mb-6"></span>
                {children}
            </div>
        </section>
    );
};

export default SectionHero;
